import { useQuery } from '@apollo/client/react';
import { type BasicPassFragment, GetPassesDocument } from '@drycut/graphql';
import { Navigation } from '@drycut/navigation';
import { ActionButtons, Button, Heading, Loader, Para, Stack } from '@drycut/ui-components';
import { useMemo } from 'react';

import { PassCard } from './PassCard';

type Props = {
  storeSlug?: string;
};

export function PassesList({ storeSlug }: Props): React.ReactElement {
  const { loading, data } = useQuery(GetPassesDocument);
  const passes = data?.passes?.nodes || [];
  const existingPasses = passes.filter((node): node is BasicPassFragment => Boolean(node));
  const sortedPasses = useMemo(() => {
    return existingPasses.sort((a) => (a.specialPromotion ? -1 : 1));
  }, [existingPasses]);

  if (loading) {
    return <Loader />;
  }

  // If store is provided, we are in manual mode and want to keep the store slug in the URL so we
  // can redirect back to the store after the purchase is completed.
  const basePath = storeSlug ? `/${storeSlug}/passes` : '/passes';

  return (
    <Stack gap={6} className="items-center h-full">
      <Stack>
        <Heading variant="h2">DRYPASS</Heading>
        <Para align="center" size="sm">
          Wähle Deinen gewünschten DRYPASS
        </Para>
      </Stack>

      <Stack gap={10} className="mt-2 w-full">
        {sortedPasses.map((pass) => (
          <PassCard pass={pass} key={pass.id} to={`${basePath}/${pass.id}/purchase`} />
        ))}
      </Stack>

      <Stack gap={2} className="px-2">
        <Para size="sm" align="center" className="text-zinc-500" pretty>
          Spare bei jedem DRYCUT. Nach Zahlung erhältst Du einen Code per SMS, den Du oder eine
          andere Person in allen Salons für die entsprechende Anzahl Cuts einlösen kannst.
        </Para>

        <Para size="sm" align="center" className="text-zinc-500 " pretty>
          Die Zahlung erfolg mit den normalen Zahlungsmöglichkeiten (Kreditkarte, TWINT, Apple Pay,
          etc.), alternativ ist es auch möglich in den Salons den Pass direkt mit EC- oder
          Post-Karte zu beziehen.
        </Para>
      </Stack>

      <ActionButtons>
        <Button as="a" href={Navigation.HOME_URL}>
          Cancel
        </Button>
      </ActionButtons>
    </Stack>
  );
}
